import { Component, OnInit } from '@angular/core';
// import { fadeInLeftOnEnterAnimation } from 'angular-animations';
// import { trigger, transition, state, style, animate } from '@angular/animations';
// import { bounce } from 'ng-animate';
// import { trigger, transition, animate, style } from '@angular/animations'

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  // animations: [
  //   trigger('slideInOut', [
  //     transition(':enter', [
  //       style({transform: 'translateY(-100%)'}),
  //       animate('200ms ease-in', style({transform: 'translateY(0%)'}))
  //     ]),
  //     transition(':leave', [
  //       animate('200ms ease-in', style({transform: 'translateY(-100%)'}))
  //     ])
  //   ])
  // ]
  // animations: [
  //   trigger('bounce', [transition('* => *', useAnimation(bounce))])
  // ],
})
export class AboutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
